import { Theme } from './types/serverConfig';

export const getTheme = (themeConfig: Theme): Theme => {
    return {
        palette: {
            text: themeConfig.palette.text,
            primary: themeConfig.palette.primary,
            secondary: themeConfig.palette.secondary,
            regionColor: themeConfig.palette.regionColor,
        },
        overrides: {
            MuiTypography: themeConfig.overrides?.MuiTypography,
            MuiInputBase: themeConfig.overrides?.MuiInputBase,
        },
    };
};
